import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import * as APIHelper from '../../Helper/apiFetch';
import * as nativeEvents from '../../Helper/native';
import Congratulation from '../congratulation';
import Loader from './components/Loader';
import CampaignTimer from './components/CampaignTimer';
import HeaderBanner from './components/HeaderBanner';
import ValentinesBanner from './components/ValentinesBanner';
import CardSpendSection from './components/CardSpendSection';
import { useTokenManager } from './hooks/useTokenManager';
import { useTimers } from './hooks/useTimers';
import { useCampaignData } from './hooks/useCampaignData';
import { CAMPAIGN_CONFIG as DEFAULT_CONFIG } from './constants';

const initiaData = require('../urlEncodeTest.json');

const NewYearCamp2026 = () => {
  const navigate = useNavigate();
  const { hasAccessToken, setHasAccessToken } = useTokenManager();
  const { remainingTime } = useTimers();
  const {
    shimmerLoader,
    campaignData,
    campaignConfig,
    loadingLevel,
    setLoadingLevel,
  } = useCampaignData(hasAccessToken, setHasAccessToken);

  // Merge campaign config with defaults
  const finalCampaignConfig = campaignConfig || DEFAULT_CONFIG;

  const [congratsPopup, setCongratsPopup] = useState(false);
  const [congratsTitle, setCongratsTitle] = useState(initiaData.congratulations);
  const [dailyDealsMerchantId, setDailyDealsMerchantId] = useState(null);
  const [showValentineBrandsScreen, setShowValentineBrandsScreen] = useState(false);
  // Extract derived values from campaign data
  const cardType = campaignData?.data?.cardIssued?.toUpperCase() || 'ELITE';
  const cardPaymentStatus = campaignData?.cardPaymentStatus ?? true;
  const progress = campaignData?.progress || 0;
  const levelTxnAmnt = campaignData?.userSpendInfo?.totalTxnAmt || 0;
  const resData = campaignData;
  
  // Extract cardSpndSteps data from API response
  // The API returns { error: false, data: { activateCard, loadCard, spend500, streak, ... } }
  const cardSpndStepsData = campaignData?.data || campaignData;

  const showLoader = shimmerLoader || !hasAccessToken;

  // Valentine's campaign: Runs from Feb 19th to 23rd
  const isValentine = (() => {
    const now = new Date();
    const month = now.getMonth(); // 0-indexed, Feb = 1
    const date = now.getDate();
    return month === 1 && date >= 17 && date <= 23;
  })();

  // Handle claim reward
  const handleClaimReward = async (level) => {
    try {
      setLoadingLevel((prev) => ({ ...prev, [level]: true }));
      const resp = await APIHelper.claimJuneReward(level);

      if (resp.error) {
        navigate('/error');
        return;
      }

      setCongratsPopup(true);
      setCongratsTitle((title) => {
        const updatedTitle = { ...title };
        const rewardAmount = resp.rewards?.sats || resp.rewards || 0;
        updatedTitle.reward = rewardAmount;
        
        if (rewardAmount) {
          let levelMessage = '';
          switch (level) {
            case 'CARD_ACTIVATED':
              levelMessage = `Congratulations! You've earned <b>${rewardAmount}</b> Sats for activating your card`;
              break;
            case 'CARD_LOAD':
              levelMessage = `Congratulations! You've earned <b>${rewardAmount}</b> Sats for loading your card`;
              break;
            case 'SPEND':
              levelMessage = `Congratulations! You've earned <b>${rewardAmount}</b> Sats for spending ₹500 or more`;
              break;
            case 'levelOne':
              levelMessage = `Congratulations! You've earned <b>${rewardAmount}</b> Sats`;
              break;
            case 'levelTwo':
              levelMessage = `Congratulations! You've earned <b>${rewardAmount}</b> Sats`;
              break;
            default:
              levelMessage = `Congratulations! You've earned <b>${rewardAmount}</b> Sats`;
          }
          updatedTitle.msg1 = levelMessage;
        }
        return updatedTitle;
      });
    } catch (e) {
      console.error('Error claiming reward:', e);
    } finally {
      setLoadingLevel((prev) => ({ ...prev, [level]: false }));
    }
  };


  // Handle congrats popup action
  const handleCongratsAction = () => {
    setCongratsPopup(false);
    if (dailyDealsMerchantId) {
      window.location.reload();
      nativeEvents.goMerchant(dailyDealsMerchantId);
    } else {
      window.location.reload();
    }
  };

  // Handle share
  const shareWithFriends = () => {
    nativeEvents.shareWithFriends(initiaData.floatingShareMsg.msg);
  };

  // Add spinner animation keyframes
  useEffect(() => {
    const spinKeyframes = `
      @keyframes spin {
        to {
          transform: rotate(360deg);
        }
      }
    `;
    const styleSheet = document.createElement('style');
    styleSheet.innerText = spinKeyframes;
    document.head.appendChild(styleSheet);
    return () => {
      document.head.removeChild(styleSheet);
    };
  }, []);

  return (
    <div
      style={{
        overflow: 'hidden',
        width: '100%',
        height: '100%',
        ...(isValentine
          ? {
             /*  backgroundImage:
                "url('https://assets.gosats.io/notification/2026/2/1770702872909')",
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat', */
              backgroundColor: '#000000',
            }
          : {}),
      }}
>
      {showLoader ? (
        <Loader />
      ) : (
        <>
        <div className="headder" style={{ backgroundImage: isValentine ? 'none' : 'url(https://assets.gosats.io/notification/2025/12/1766467081344)',
          marginBottom: isValentine ? '0px' : '0px'
         }}>
          {isValentine ? (
            <ValentinesBanner
              cardType={cardType}
              cardPaymentStatus={cardPaymentStatus}
              onShare={shareWithFriends}
              onBrandScreenChange={setShowValentineBrandsScreen}
              showBrandsScreen={showValentineBrandsScreen}
              remainingTime={remainingTime}
            />
          ) : (
            <HeaderBanner
              cardType={cardType}
              cardPaymentStatus={cardPaymentStatus}
              onShare={shareWithFriends}
            />
          )}
        </div>
          

          {/* <CardSpendSection
            cardType={cardType}
            cardPaymentStatus={cardPaymentStatus}
            progress={progress}
            levelTxnAmnt={levelTxnAmnt}
            resData={resData}
            loadingLevel={loadingLevel}
            onClaimReward={handleClaimReward}
            campaignConfig={finalCampaignConfig}
            cardSpndStepsData={cardSpndStepsData}
          /> */}

          {congratsPopup && (
            <Congratulation title={congratsTitle} onAction={handleCongratsAction} />
          )}
        </>
      )}
    </div>
  );
};

export default NewYearCamp2026;
